import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import PageContainer from "~/components/PageContainer";
import Login from "~/pages/Auth/Login";
import PageId from "~/utils/PageId";

export const Route = createFileRoute("/")({
  staticData: {
    pageId: PageId.LOGIN,
    titleKey: "pageTitles.login",
    hideNav: true,
  },
  component: LoginRoute,
});

function LoginRoute() {
  const { t } = useTranslation("common");
  return (
    <PageContainer title={t("pageTitles.login")} hideNav>
      <Login />
    </PageContainer>
  );
}
